import { defineMessages } from 'react-intl';
import { VENUE_SOURCE } from 'constants/logic';

const messages = defineMessages({
  blog: {
    id: 'links.blog',
    defaultMessage: 'After Class blog',
  },
  faq: {
    id: 'links.help-center',
    defaultMessage: 'Help center',
  },
});

export default {
  faq: {
    href: 'https://partnersupport.classpass.com/help/s/',
    message: messages.faq,
  },
  blog: {
    href: 'https://classpass.com/partners/blog',
    message: messages.blog,
  },
  contact: {
    partnerSuccessHref: 'https://partnersupport.classpass.com/help/s/contact-partner-support',
  },
  contactJapan: {
    href: 'https://partnersupport.classpass.com/help/s/contact-partner-support-japan',
  },
  classInsights: {
    href: 'https://classpass.my.site.com/help/s/article/Understanding-your-Class-Insights',
  },
  resources: {
    href: 'https://classpass.com/partners/resources',
  },
  smartspot: {
    learnMore: 'https://partnersupport.classpass.com/help/s/article/what-is-smartspot',
  },
  terms: {
    href: '/help/terms',
  },
  privacyPolicy: {
    href: 'https://classpass.com/privacy/',
  },
  termsAdditionalDefinitions: {
    href: 'https://classpass.com/terms/additional-definitions',
  },
  termsOfUse: {
    href: 'https://classpass.com/terms/',
  },
  /* Note: make sure short country codes are mapped to long codes, see: constants/countryCodeToStaticValueMaps.js */
  termsCountryMapping: {
    ARE: '/help/uae/terms', // United Arab Emirates
    AUT: '/help/europe/terms', // Austria
    AUS: '/help/australia/terms', // Australia
    BEL: '/help/europe/terms', // Belgium
    BRA: '/help/brazil/terms', // Brazil
    CAN: '/help/canada/terms', // Canada
    CHE: '/help/europe/terms', // Switzerland
    DEU: '/help/europe/terms', // Germany
    DNK: '/help/europe/terms', // Denmark
    ESP: '/help/spain_portugal/terms', // Spain
    FIN: '/help/europe/terms', // Finland
    FRA: '/help/france/terms', // France
    GBR: '/help/uk/terms', // United Kingdom
    HKG: '/help/hongkong/terms', // Hong Kong
    IDN: '/help/idn/terms', // Indonesia
    IRL: '/help/europe/terms', // Ireland
    IND: '/help/apac/terms', // India
    JPN: '/help/japan/terms', // Japan
    KWT: 'help/kuwait/terms', // Kuwait
    MYS: '/help/malaysia/terms', // Malaysia
    NLD: '/help/europe/terms', // Netherlands
    NOR: '/help/europe/terms', // Norway
    NZL: '/help/nzl/terms', // New Zealand
    PHL: '/help/phl/terms', // Philippines
    PRT: '/help/spain_portugal/terms', // Portugal
    QAT: '/help/qatar/terms', // Qatar
    SWE: '/help/europe/terms', // Sweden
    SGP: '/help/singapore/terms', // Singapore
    THA: '/help/thailand/terms', // Thailand
    USA: '/help/us/terms', // United States
  },
  trialerProgramTerms: {
    href: 'https://classpass.com/partners/trialer-program-standard-terms',
  },
  trialerProgramTermsAgreement: {
    href: 'https://classpass.com/partners/trialer-program-terms-agreement',
  },
  changeAppointmentsStartTime: {
    href: 'https://partnersupport.classpass.com/help/s/article/how-do-i-change-the-start-time-of-appointments',
  },
  userMessagingUsageGuidelines: {
    href: 'https://classpass.com/blog/user-messaging-feature-terms-and-conditions/',
  },
  signUp: {
    href: 'https://classpass.com/partners',
  },
  venueSourceHelpLinks: {
    [VENUE_SOURCE.EVERSPORTS]: 'https://partnersupport.classpass.com/help/s/article/Eversports-Integration-Steps',
    [VENUE_SOURCE.GLOFOX]: 'https://partnersupport.classpass.com/help/s/article/Glofox-Integration-Steps',
    [VENUE_SOURCE.MAGICLINE]: 'https://partnersupport.classpass.com/help/s/article/Magicline---Integration-Steps',
    [VENUE_SOURCE.REZEVE]: 'https://partnersupport.classpass.com/help/s/article/rezerv-integration-steps',
  },
};
